export enum UserSettingsPage {
  USER_DATA = 'user-data',
  NOTIFICATION_SETTINGS = 'notification-settigs',
  FAMILY_MEMBERS = 'family-members',
}

export const UserSettingsPageNumber: Record<UserSettingsPage, string> = {
  [UserSettingsPage.USER_DATA]: '0',
  [UserSettingsPage.FAMILY_MEMBERS]: '1',
  [UserSettingsPage.NOTIFICATION_SETTINGS]: '2',
};
